import {useEffect, useRef, useState} from 'react';

import {useVariableHeightContext} from './scroll/variableHeightContext';

/*
 * Hooks.
 */

export function useImageLoadingState(src: string) {
  const [isLoaded, setIsLoaded] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);
  const {onElementLoaded} = useVariableHeightContext();

  useEffect(() => {
    if (imageRef.current && imageRef.current.complete && !isLoaded) {
      setIsLoaded(true);
      onElementLoaded();
    }
  }, [src, isLoaded, onElementLoaded]);

  return {
    onLoad: () => {
      if (!isLoaded) {
        setIsLoaded(true);
        onElementLoaded();
      }
    },
    imageRef,
    isLoaded,
  };
}
